module.exports = __webpack_public_path__ + "img/Tahoe2.4aca844d.png";